export default {"src":"/_next/static/media/homes.c45ee895.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};